var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
import { useState, useRef, useEffect } from 'react';
import { generateFilePreviews } from 'src/Utils/filePreviewUtils';
export var useFileHandling = function () {
    var _a = useState([]), files = _a[0], setFiles = _a[1];
    var _b = useState([]), filePreviews = _b[0], setFilePreviews = _b[1];
    var fileInputRef = useRef(null);
    useEffect(function () {
        if (files.length > 0) {
            generateFilePreviews(files).then(setFilePreviews);
        }
        else {
            setFilePreviews([]);
        }
    }, [files]);
    var handleFileSelect = function (event) {
        var selectedFiles = event.target.files;
        if (selectedFiles) {
            var newFiles_1 = Array.from(selectedFiles);
            setFiles(function (prev) { return __spreadArrays(prev, newFiles_1); });
        }
        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };
    var handleRemoveFile = function (index) {
        setFiles(function (prev) { return prev.filter(function (_, i) { return i !== index; }); });
    };
    var addFiles = function (newFiles) {
        setFiles(function (prev) { return __spreadArrays(prev, newFiles); });
    };
    var handleAttachClick = function () {
        var _a;
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    var clearFiles = function () {
        setFiles([]);
        setFilePreviews([]);
    };
    var formatFileSize = function (bytes) {
        if (bytes === 0)
            return '0 Bytes';
        var k = 1024;
        var sizes = ['Bytes', 'KB', 'MB', 'GB'];
        var i = Math.floor(Math.log(bytes) / Math.log(k));
        return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
    };
    return {
        files: files,
        filePreviews: filePreviews,
        fileInputRef: fileInputRef,
        handleFileSelect: handleFileSelect,
        handleRemoveFile: handleRemoveFile,
        handleAttachClick: handleAttachClick,
        addFiles: addFiles,
        clearFiles: clearFiles,
        formatFileSize: formatFileSize,
    };
};
